import { useEffect, useState } from "react";
import { epicengageSupabasev1 } from "../integrations/supabase/client";
import { useAuth } from "./useEngageV1Auth";

export const useIsAdmin = () => {
  const { user, loading: authLoading } = useAuth();
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    if (authLoading) return;
    if (!user) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }
    (async () => {
      const { data, error } = await epicengageSupabasev1
        .from("admin_users")
        .select("id")
        .eq("user_id", user.id)
        .maybeSingle();
      if (!active) return;
      if (error) console.error(error);
      setIsAdmin(!!data);
      setLoading(false);
    })();
    return () => { active = false; };
  }, [user, authLoading]);

  return { isAdmin: !!isAdmin, loading: loading || authLoading };
};
